<div class="container-xxl container-p-y">
    <div class="misc-wrapper">
      <h1 class="mb-2 mx-2 secondary-font">{{'PageNotFound' | translate}}</h1>
      <p class="mb-4 mx-2">{{'NotFoundDescription' | translate}}</p>
      <a [routerLink]="'/home'" class="btn btn-primary">{{'BackToHome' | translate}}</a>
      <div class="mt-3">
        <img src="../../assets/img/illustrations/page-misc-error-light.png" alt="page-misc-error-light" width="500" class="img-fluid" data-app-light-img="illustrations/page-misc-error-light.png" data-app-dark-img="illustrations/page-misc-error-dark.png">
      </div>
    </div>
  </div>